<template>
  <div class="permissions-error-item-layout">
    <v-flex class="permissions-error-prompt-wrapper-root">
      <v-row class="permissions-error-prompt-wrapper-root">
        <v-col class="image">
          <v-img
            contain
            :src="require('@/assets/images/permissions-error.svg')"
            :aspect-ratio="4 / 2"
          />
        </v-col>
        <v-col class="permissions-error-prompt-wrapper">
          <div class="header">
            {{ $t(permissionsErrorData.header) }}
          </div>
          <div class="content">
            <p>{{ $t(permissionsErrorData.content.subheader) }}</p>
            <br>
            <p class="prelink">{{ $t(permissionsErrorData.content.prelink) }}</p>
            <v-btn rounded color="primary" @click="$router.push('/')">
              {{ $t(permissionsErrorData.link.text) }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-flex>
  </div>
</template>
<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import './styles/permissions-error-item.scss';

@Component
export default class PermissionsErrorItem extends Vue {
  private permissionsErrorData = {
    header: 'common.error.permissions_denied.header',
    content: {
      subheader: 'common.error.permissions_denied.subheader',
      prelink: 'common.error.permissions_denied.prelink'
    },
    link: {
      text: 'common.error.permissions_denied.link'
    }
  };
}
</script>
